// src/plugins/vuetify.js

import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/dist/vuetify.min.css'
// Translation provided by Vuetify (typescript)
import es from 'vuetify/src/locale/es'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
    },
    icons: {
      iconfont: 'mdi' || 'fa' || 'md' // default - only for display purposes
    },
    lang: {
      locales: { es },
      current: 'es'
    },
  })
